<template>
  <div>
    <BillssMonitoring :titlee="'Water Bill'">

    </BillssMonitoring>
  </div>
</template>
<script>
  import BillssMonitoring from './BillssMonitoring'

  export default {
    components: {
      BillssMonitoring,
    },
  }
</script>
